export { DMS_MODULE } from '../constants';
export const NAME = 'AppointmentList';
export const API_NAME = 'AppointmentList';
export const CRUMB_LABEL_KEY = 'Appointment Taken List';


export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };

